export default __webpack_public_path__ + "static/media/CAT_NOISE.6b191c4d.wav";